import React from 'react';
import { Button, FormControl, Dropdown, MenuItem } from 'react-bootstrap';
import {Typeahead} from 'react-bootstrap-typeahead';

import 'react-bootstrap-typeahead/css/Typeahead.css';

const SEARCH_TYPES = [
	{
		type : 'title',
		key  : 'Title'
	},
	{
		type : 'category',
		key  : 'Organization'
	}
]

const _formatTypeAheadOptions = (data) => {
    
    return data.map((x,i) => {
        return {
            id: x.slug,
            label: x.title
        }
    })
}

export const SectionSearch = (props) => {
    return (
        <div className="row" id="search-form">
            <form onSubmit={props.onSubmit} method="GET">
                <div className="col-md-8 col-sm-12 col-xs-12">
                    <span style={{}}>
                    {props.data.key === "Organization" && <Typeahead
                        onChange={(selected) => {
                            props.onSubmit();
                        }}
                        ref={(typeahead) => {
                            props.parent.typeahead = typeahead 
                        }}
                        inputProps={{type:"search"}}
                        type="search"
                        name="term"
                        placeholder="&#xF002; Search Summaries..."
                        options={_formatTypeAheadOptions(props.options) || []}
                    />}
                    
                    {props.data.key !== "Organization" && <FormControl
                        type="text"
                        name="term"
                        value={props.data.term}
                        onChange={props.onSearchInputChange}
                        placeholder="&#xF002; Search Summaries..."
                    />}
                    <span className="search-clear-btn" style={{position:'absolute',right:34,top:'13%',fontSize:25,cursor:'pointer'}} onClick={()=>{
                        if(props.parent.typeahead) {
                            props.parent.typeahead.getInstance().clear()
                        } else {
                            props.parent.setState({search : {term:'', type:props.parent.state.search.type, key:props.parent.state.search.key}});
                        }
                    }}>&times;</span>
                    </span>
                </div>
                <div className="col-md-2 col-sm-12 col-xs-12">
                    <Dropdown
                        block
                        vertical
                        name="criteria"
                        bsStyle={"default"}
                        title={props.data.key}
                        id={`dropdown-basic`}
                    >
                    <Dropdown.Toggle block>
                        { props.data.key }
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {SEARCH_TYPES.map((key, i) => {
                            return <MenuItem
                                active={props.data.key === key.key}
                                key={i} 
                                onSelect={
                                    (context, e) => {
                                        e.preventDefault();
                                        props.onSearchTypeSelect(e, key)
                                    } 
                                }>{key.key}
                            
                            </MenuItem>}) 
                        }
                    </Dropdown.Menu>
                </Dropdown>
                </div>
                <div className="col-md-2 col-sm-12 col-xs-12">
                    <Button type="submit" block className="btn btn-primary"><span className="fa fa-search">&nbsp;</span> Search</Button>
                </div>
            </form>
        </div>
    )
}